import Search from "./Search";
import logo from "../../Assets/images/logo.svg";
import CloseIcon from "@mui/icons-material/Close";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  List,
  Button,
  Drawer,
  ListItem,
  Collapse,
  useTheme,
  ListItemButton,
  Typography, // Typography import kiya gaya hai
} from "@mui/material";

const MenuDrawer = (props) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const drawerWidth = "100%";
  const categories = props.categories;
  const subCategories = props.subCategories;
  // ✅ Brands data props se liya gaya
  const brands = props.brands || []; 

  const [openCategories, setOpenCategories] = useState({});
  // ✅ Brands toggle state
  const [openBrands, setOpenBrands] = useState(false); 

  const styles = {
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
      "& .MuiDrawer-paper": {
        width: drawerWidth,
      },
    },
    container: {
      p: 2,
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
    },
    closeIconContainer: {
      display: "flex",
      padding: "10px",
      borderRadius: "50%",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: theme.palette.primary.main,
    },
    // Category/Brands Button style
    categoryButton: { 
      justifyContent: 'space-between', 
      width: '100%', 
      color: theme.palette.text.primary,
      padding: '8px 16px',
    },
    // Dropdown list item style
    listItem: { 
      paddingLeft: theme.spacing(4), 
      fontSize: 'small', 
    }
  };

  const resetStatesAndClose = () => {
    props.setOpen(false);
    setOpenCategories({});
    setOpenBrands(false);
    document.documentElement.scrollTo(0, 0); // Scroll to top added for consistency
  };

  const handleNavigation = (path) => {
    navigate(path);
    resetStatesAndClose();
  };

  const handleHomeClick = () => handleNavigation("/");
  const handleCreateFastOrderClick = () => handleNavigation("/fastorder");
  const handleTrackOrderClick = () => handleNavigation("/track-order");
  const handleFeedbackClick = () => handleNavigation("/Feedback");
  const handleOurBranchesClick = () => handleNavigation("/branches");
  const handleProfileClick = () => handleNavigation("/profile");
  const handleLoginClick = () => handleNavigation("/account");
  // ✅ New Brands main page click handler
  const handleBrandsClick = () => handleNavigation("/brands");

  const handleCategoryItemClick = (id) => {
    if (id === 49) {
      handleNavigation("/showproducts");
    } else {
      handleNavigation(`/subcategory/${id}`);
    }
  };

  // ✅ New Brand item click handler
  const handleBrandItemClick = (slug) => handleNavigation(`/brand/${slug}`);

  const handleCategoryToggle = (categoryId) => {
    setOpenCategories(prevState => ({ ...prevState, [categoryId]: !prevState[categoryId] }));
    setOpenBrands(false); // Brands ko band kar dein jab category kholein
  };

  // ✅ Brands toggle function
  const handleBrandsToggle = () => {
    setOpenBrands(prevState => !prevState);
    setOpenCategories({}); // Categories ko band kar dein jab brands kholein
  };

  return (
    <>
      <Drawer
        open={props.open}
        sx={styles.drawer}
        variant="temporary"
        onClose={() => props.setOpen(false)}
      >
        <Box sx={styles.container}>
          <div style={{ cursor: "pointer" }}>
            <img
              src={logo}
              alt={"NMP Pharmacy"}
              style={{ height: "90%", width: "90%" }}
              onClick={handleHomeClick}
            />
          </div>

          <div style={styles.closeIconContainer}>
            <CloseIcon
              style={{ color: "#ffffff" }}
              onClick={() => props.setOpen(false)}
            />
          </div>
        </Box>

        <Box sx={{ p: 2, marginRight: 2 }}>
          <Search setOpen={props.setOpen} />
        </Box>

        <List>
          <ListItemButton onClick={handleHomeClick}>Home</ListItemButton>
          <ListItemButton onClick={handleCreateFastOrderClick}>Create Fast Order</ListItemButton>
          <ListItemButton onClick={handleTrackOrderClick}>Track Order</ListItemButton>
          <ListItemButton onClick={handleFeedbackClick}>Feedback</ListItemButton>
          <ListItemButton onClick={handleOurBranchesClick}>Our Branches</ListItemButton>
          {props.authStatus ? (
            <ListItemButton onClick={handleProfileClick}>Profile</ListItemButton>
          ) : (
            <ListItemButton onClick={handleLoginClick}>Login</ListItemButton>
          )}
          <hr />
          
          {/* Brands Section */}
          {brands.length > 0 && (
            <div style={{ marginLeft: 8 }}>
              <Button sx={styles.categoryButton} onClick={handleBrandsToggle}>
                <Typography variant="body1">Brands</Typography>
                {openBrands ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </Button>

              <Collapse in={openBrands}>
                <List>
                  {brands.map((brand, index) => (
                    <ListItem
                      key={index}
                      style={styles.listItem}
                      onClick={() => handleBrandItemClick(brand.slug)}
                    >
                      {brand.name}
                    </ListItem>
                  ))}
                   
                </List>
              </Collapse>
            </div>
          )}
          {/* End Brands Section */}

          {categories.map((category, index) => {
            const isOpen = openCategories[category.id] || false;

            return (
              <div key={index} style={{ marginLeft: 8 }}>
                <Button sx={styles.categoryButton} onClick={() => handleCategoryToggle(category.id)}>
                  <Typography variant="body1">{category.name}</Typography>
                  {isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </Button>

                <Collapse in={isOpen}>
                  <List>
                    {subCategories.map((subcategory, subIndex) => {
                      if (category.id === subcategory.parent_category) {
                        return (
                          <ListItem
                            key={subIndex}
                            style={styles.listItem}
                            onClick={() => handleCategoryItemClick(subcategory.id)}
                          >
                            {subcategory.name}
                          </ListItem>
                        );
                      }
                      return null;
                    })}
                  </List>
                </Collapse>
              </div>
            );
          })}
        </List>
      </Drawer>
    </>
  );
};

export default MenuDrawer;
